(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rtp-capsule-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroes() {
      document.querySelectorAll('.rtp-hero').forEach(function (hero) {
        if (hero.dataset.rtpInit) return;
        hero.dataset.rtpInit = '1';
        var want = '';
        try { want = (new URLSearchParams(window.location.search).get('utm_content') || '').toLowerCase(); } catch (e) {}
        var def = (hero.dataset.defaultCapsule || 'shema').toLowerCase();
        var caps = Array.prototype.slice.call(hero.querySelectorAll('.rtp-hero-capsule'));
        var byKey = {};
        caps.forEach(function (c) { byKey[(c.dataset.capsuleKey || '').toLowerCase()] = c; });
        var chosen = byKey[want] || byKey[def] || caps[0];
        caps.forEach(function (c) {
          if (c === chosen) { c.removeAttribute('hidden'); } else { c.setAttribute('hidden', ''); }
          var btn = c.querySelector('.rtp-hero-play');
          var audio = c.querySelector('.rtp-hero-audio');
          if (btn && audio && !btn.dataset.wired) {
            btn.dataset.wired = '1';
            btn.addEventListener('click', function () {
              if (audio.paused) { audio.play(); c.classList.add('is-playing'); }
              else { audio.pause(); c.classList.remove('is-playing'); }
            });
            audio.addEventListener('ended', function () { c.classList.remove('is-playing'); });
          }
        });
      });
    }
    if (document.readyState !== 'loading') initHeroes();
    else document.addEventListener('DOMContentLoaded', initHeroes);
  })();

  } catch(e) { console.error(e); }
})();
})();
